/**
 * 输入输出全屏展示组件
 * zxw
 * 创建时间 2026-02-02
 */

import CNF from '../../incs/Config';
import { useState, useEffect } from 'react';
import { Modal, Typography } from 'antd';

import { XMarkdown } from '@ant-design/x-markdown';
import Latex from '@ant-design/x-markdown/plugins/Latex';   // 公式
import { CodeHighlighter, } from '@ant-design/x';
import '@ant-design/x-markdown/themes/light.css';

// 思维链
import XinYuanThink from './XinYuanThink';
import {
    ImageSkeleton,
    IncompleteLink,
    TableSkeleton,
    HtmlSkeleton,
    IncompleteEmphasis,
    IncompleteInlineCode,
    WelcomeCard,
    Code,
} from '../../components/Incomplete';

// 图表
import ChartPiePercent from './reportTemplates/ChartPiePercent'; // 分类百分比（饼图）
import ChartLineUTACD from './reportTemplates/ChartLineUTACD'; // 每日用户活跃统计
import ChartLineUTECY from './reportTemplates/ChartLineUTECY'; // 年度入职人数趋势

import ChartLineDateCount from './reportTemplates/ChartLineDateCount'; // 日期数量走势组件（曲线图）
import ChartIntervalTypeCount from './reportTemplates/ChartIntervalTypeCount'; // 类型数量分布组件（柱状图）

import ChartILYearAmount from './reportTemplates/ChartILYearAmount';   // 年度金额趋势统计（柱状和曲线混合图）
import ChartIntervalMonthIOAmount from './reportTemplates/ChartIntervalMonthIOAmount'; // 月份收支统计（柱状图）

const { Text } = Typography;

const IOPutFullScreen = (props) => {
    const [open, setOpen] = useState(false);

    const cancel = () => { setOpen(false); };

    useEffect(() => {
        setOpen(props.open);
    }, [props]);

    const className = props.isDarkMode ? 'x-markdown-dark' : 'x-markdown-light';

    return <Modal
        title={<span style={{ color: CNF.baseTextColor }}>{props.title}</span>}
        open={open}
        onCancel={cancel}
        footer={null}
        width={'100%'}
        style={{
            top: 20,
        }}
        styles={{
            container: {
                paddingLeft: 0,
                paddingRight: 0,
            },
            header: {
                paddingLeft: 20,
                paddingBottom: 12,
                borderBottom: `1px solid ${CNF.baseBorderSolidColor}`,
            },
            body: {
                padding: 20,
            }
        }}
        destroyOnHidden={true}
    ><div style={{
        maxHeight: 'calc(100vh - 160px)',
        scrollbarColor: '#d9d9d9 transparent',
        scrollbarWidth: 'thin',
        overflowY: 'auto',
    }}>
            {
                props.format === 'Json' ? <CodeHighlighter
                    lang='json'
                    styles={{
                        header: {
                            display: 'none',
                        },
                        code: {
                            border: 0,
                            background: '#fff'
                        }
                    }}>{JSON.stringify(props.content, null, 2)}</CodeHighlighter>
                    :
                    props.format === 'Text' ? <Text style={{ color: CNF.baseTextColor, fontSize: CNF.fontSizeSM, }}>{JSON.stringify(props.content)}</Text>
                        :
                        <XMarkdown
                            content={props.content}
                            className={className}
                            paragraphTag='div'
                            openLinksInNewTab
                            dompurifyConfig={{ ADD_ATTR: ['icon', 'description'] }}
                            style={{
                                wordWrap: 'break-word',
                                overflowWrap: 'break-word',
                                overflowX: 'hidden',
                                padding: 8,
                                width: 'auto',
                            }}
                            components={{
                                code: Code,
                                welcome: WelcomeCard,
                                'think': XinYuanThink,
                                'incomplete-image': ImageSkeleton,
                                'incomplete-link': IncompleteLink,
                                'incomplete-table': TableSkeleton,
                                'incomplete-html': HtmlSkeleton,
                                'incomplete-emphasis': IncompleteEmphasis,
                                'incomplete-inline-code': IncompleteInlineCode,
                                'chart-pie-percent': ChartPiePercent,
                                'chart-line-utacd': ChartLineUTACD,
                                'chart-line-utecy': ChartLineUTECY,
                                'chart-line-date-count': ChartLineDateCount,
                                'chart-interval-type-count': ChartIntervalTypeCount,
                                'chart-il-year-amount': ChartILYearAmount,
                                'chart-interval-month-io-amount': ChartIntervalMonthIOAmount,
                            }}
                            config={{
                                extensions: Latex(),
                            }}
                        />
            }
        </div>
    </Modal >
}

export default IOPutFullScreen;